import {AuthProviderType} from "../../domain/providers";
import {getProviderIcon, ProviderIcon} from "./UserAccountListItem";
import {UserAvatar} from "./UserAvatar";

type UserCardProps = {
    provider: AuthProviderType;
    displayName?: string;
    email?:string;
}

export const UserCard = ({provider, displayName, email}: UserCardProps) => {
    const providerIcon = <ProviderIcon icon={getProviderIcon(provider)} testId={`provider-icon-${provider}`}/>
    return (
        <div
            className={"flex-col flex items-center justify-center bg-gray-50 rounded-2xl p-2"}
            data-testid={`user-card-with-provider-${provider}`}>
            <div className="flex items-center justify-center w-70 m-2">
                <div className="w-full content-center relative">
                    <UserAvatar displayName={displayName} email={email}/>
                    <span className="absolute top-21 -translate-y-6 left-24 translate-x-4">{providerIcon}</span>
                </div>
            </div>
            <div className="flex items-center justify-center m-2">
                {displayName || email}
            </div>
        </div>
    );
};
